export default "__VITE_ASSET__BTHYkfXM__"